import React from "react";
import PropTypes from "prop-types";

const NewPagination = ({
    currentPage,
    maxPageNumber,
    offset,
    pageSize,
    label
}) => {
    let paginationButtons = [];
    let pagination = {
        currentPage: parseInt(currentPage),
        offset: offset,
        startAt: parseInt(currentPage) - offset,
        endAt: parseInt(currentPage) + offset,
        maxPageNumber: maxPageNumber
    };
    const pageNumberButtons = () => {
        if (pagination.startAt < 1) {
            const offset = 1 - pagination.startAt;

            pagination.startAt = 1;
            pagination.endAt += offset;
        }

        if (pagination.endAt > maxPageNumber) {
            const offset = pagination.endAt - maxPageNumber;

            pagination.endAt = maxPageNumber;
            pagination.startAt -= offset;
            if (pagination.startAt <= 0) {
                pagination.startAt = 1;
            }
        }

        if (pagination.currentPage > 1) {
            paginationButtons.push(
                <a
                    key={0}
                    href={`?currentPage=${pagination.currentPage -
                        1}&pageSize=${pageSize}`}
                    className="page-button"
                >
                    <i className="fas fa-angle-double-left" />
                </a>
            );
        }

        for (let i = pagination.startAt; i <= pagination.endAt; i++) {
            paginationButtons.push(
                <a
                    key={i}
                    className={`page-button ${
                        pagination.currentPage === i ? "active" : ""
                    }`}
                    href={`?currentPage=${i}&pageSize=${pageSize}`}
                >
                    {i}
                </a>
            );
        }

        if (pagination.currentPage < pagination.maxPageNumber) {
            paginationButtons.push(
                <a
                    key={++pagination.maxPageNumber}
                    href={`?currentPage=${pagination.currentPage +
                        1}&pageSize=${pageSize}`}
                    className="page-button"
                >
                    <i className="fas fa-angle-double-right" />
                </a>
            );
        }

        return paginationButtons;
    };

    return (
        <div className="pagination__row">
            <div>
                Page {pagination.currentPage} of {maxPageNumber} | {pageSize}{" "}
                {label}
            </div>
            <div>{pageNumberButtons()}</div>
        </div>
    );
};

NewPagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    maxPageNumber: PropTypes.number.isRequired,
    offset: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    pageSizeOptions: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired
};

export default NewPagination;
